import {
  extendVariants,
  SelectItem,
  HeroSelect as StyledSelect
} from '@cavela/ui';

interface SelectProps {
  label: string;
  items: { key: string; label: string }[];
  placeholder?: string;
  isInvalid?: boolean;
  isDisabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const ExtendedSelect = extendVariants(StyledSelect, {
  variants: {
    color: {
      default: {
        label: '!text-secondary-text',
        value: 'text-gray-4',
        trigger: [
          'shadow-none',
          '!bg-white border-1 border-gray-4',
          'hover:!bg-white',
          'focus-within:!bg-white focus-within:border-foreground',
          '!cursor-text',
          'rounded-lg',
          'font-medium'
        ]
      }
    },
    isInvalid: {
      true: {
        base: ''
      }
    },
    isDisabled: {
      true: {
        base: '!opacity-100'
      }
    },
    size: {
      md: {
        trigger: '!h-[36px] !min-h-[36px]'
      }
    }
  },
  defaultVariants: {
    color: 'default',
    textSize: 'base',
    placeholder: ' ',
    labelPlacement: 'outside',
    variant: 'bordered'
  }
});

const Select: React.FC<SelectProps | any> = ({
  label,
  items = [],
  size = 'lg',
  fullWidth = false,
  customComponent,
  setIsOpen,
  isOpen = undefined,
  ...props
}) => {
  return (
    <ExtendedSelect
      classNames={{ base: fullWidth ? 'w-full' : 'w-[240px]' }}
      label={label}
      size={size}
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (open !== isOpen && setIsOpen) {
          setIsOpen(open);
        }
      }}
      {...props}
    >
      {items.map((item: any) => (
        <SelectItem
          classNames={{ base: 'hover:!bg-gray-2 font-medium' }}
          key={item.key}
          id={item.key}
          textValue={item.label}
        >
          {customComponent ? customComponent(item) : item.label}
        </SelectItem>
      ))}
    </ExtendedSelect>
  );
};

export default Select;
